<template>
  <a-input class="sms-input" v-model="model.phone" placeholder="请输入手机号" allow-clear size="large">
    <template #prepend>+86</template>
  </a-input>
  <a-input-password class="sms-input" v-model="model.password" placeholder="请输入密码" allow-clear size="large" />
  <a-button type="primary" class="login-btn" size="large" @click="handleLogin">登录</a-button>
</template>
        
  <script setup>
import { reactive, getCurrentInstance } from "vue";
import md5 from "md5";
const post = getCurrentInstance().appContext.config.globalProperties.post;
const storageLabel = getCurrentInstance().appContext.config.globalProperties.storageLabel;
//路由
const model = reactive({
  phone: "",
  password: "",
});
function handleLogin() {
  post("/userInfo/passwordLogin", {
    phone: model.phone,
    userPassword: md5(model.password),
    loginWay:'web',
  }).then((res) => {
    if (res.success) {
      localStorage.setItem(storageLabel() , res.data.userKey);
      location.reload();
    }
  });
}
</script>
  <style lang="scss" scoped>
.sms-input {
  width: 100%;
  margin-bottom: 24px;
}
.captcha-img {
  height: 26px;
}
.login-btn {
  margin-top: 48px;
  width: 100%;
}
</style>
        